import React, { useMemo } from 'react';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import LayersIcon from '@mui/icons-material/Layers';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import './SimulationCard.css';

const fmt = (m2) => {
  if (!m2) return '—';
  if (m2 >= 1_000_000) return `${(m2 / 1_000_000).toFixed(1)} km²`;
  if (m2 >= 10_000) return `${(m2 / 10_000).toFixed(1)} ha`;
  return `${Math.round(m2)} m²`;
};

const fmtDate = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });
};

const fmtTime = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  return d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
};

const SimulationCard = ({ simulation, isSelected, onClick }) => {
  const { fire, polygons = [] } = simulation;

  const maxArea = useMemo(() => {
    const predAreas = polygons
      .filter((p) => p.type === 'predictions')
      .map((p) => p.area_m2 ?? 0);
    return predAreas.length ? Math.max(...predAreas) : (polygons[0]?.area_m2 ?? 0);
  }, [polygons]);

  const predCount = polygons.filter((p) => p.type === 'predictions').length;

  const intensity = Math.min(maxArea / 50_000_000, 1);
  const hue = Math.round(20 - intensity * 20);

  const timeLabel = fmtTime(fire.created_at);

  return (
    <button
      className={`sim-card ${isSelected ? 'sim-card--selected' : ''}`}
      onClick={() => onClick?.(simulation)}
      style={{ '--fire-hue': hue }}
    >
      {/* Ligne 1 — En-tête : réf + type */}
      <div className="sim-card__head">
        <WhatshotIcon className="sim-card__flame" style={{ fontSize: 14 }} />
        <span className="sim-card__ref">
          {fire.reference?.trim() || `#${fire.id}`}
        </span>
        <span className="sim-card__type">{fire.type}</span>
      </div>

      {/* Ligne 2 — Toutes les métadonnées condensées (wrap si nécessaire) */}
      <div className="sim-card__stats">
        <span className="sim-card__stat">
          <SquareFootIcon style={{ fontSize: 10 }} />
          {fmt(maxArea)}
        </span>
        <span className="sim-card__stat sim-card__stat--optional">
          <LayersIcon style={{ fontSize: 10 }} />
          {predCount} polygones
        </span>
        <span className="sim-card__stat">
          <AccessTimeIcon style={{ fontSize: 10 }} />
          {fire.nb_of_hours}h
        </span>
        <span className="sim-card__stat sim-card__stat--date" title="Date de création">
          <CalendarTodayIcon style={{ fontSize: 10 }} />
          <span className="sim-card__date-label">Créée le</span>{' '}
          {fmtDate(fire.created_at)}
          {timeLabel && <span className="sim-card__time"> · {timeLabel}</span>}
        </span>
      </div>

      {isSelected && <div className="sim-card__selected-dot" />}
    </button>
  );
};

export default SimulationCard;